import * as React from "react";
import styled, { css } from "styled-components";

import { Button } from "src/library/components/Button";
import { Text } from "src/library/components/Text/Text";

import { StyledInput } from "./InputFields";

interface IProps {
  isEditable: boolean;
  listName?: string;
  editListName: (listName: string) => void;
}

export const EditListName: React.ReactFCWithChildren<IProps> = ({
  isEditable, listName, editListName
}) => {
  const [ canEditName, setCanEditName ] = React.useState<boolean>(false);
  const [ editName, setEditName ] = React.useState<boolean>(false);
  const [ localName, setLocalName ] = React.useState<string | undefined>(undefined);
  const [ nameError, setNameError ] = React.useState<string | null>(null);

  const updateListName = () => {
    if (localName) {
      setEditName(false);
      editListName(localName);
    }
  };

  React.useEffect(() => {
    if (listName && !localName) {
      setLocalName(listName);
    }
  }, []);

  React.useEffect(() => {
    setCanEditName(isEditable);
  }, [ isEditable ]);

  return (
    <EditListNameWrapper>
      {!canEditName ? (
        <>
          {localName}
        </>
      ) : (
        <>
          {editName ? (
            <>
              <StyledInput
                onChange={e => {
                  setLocalName(e.target.value);

                  if (e.target.value.length > 120) {
                    setNameError("List names have a maximum of 120 characters");
                  } else {
                    setNameError(null);
                  }
                }}
                value={localName}
              />

              {nameError && (
                <Text color="error">
                  {nameError}
                </Text>
              )}

              <Button
                loading={false}
                onClick={() => updateListName()}
                disabled={!!nameError}
              >
                Confirm
              </Button>
            </>
          ) : (
            <div className="inactive-edit-view">
              {localName}

              <Button
                loading={false}
                onClick={() => setEditName(true)}
              >
                Edit
              </Button>
            </div>
          )}
        </>
      )}
    </EditListNameWrapper>
  );
};

const EditListNameWrapper = styled.div`
  ${({ theme }) => css`
    .inactive-edit-view {
      display: flex;
      align-items: center;
    }

    .inactive-edit-view button {
      margin-left: ${theme.spacing.margins.md};
    }
  `}
`;

export default EditListName;
